import React from "react";
import styled from "styled-components";
import Spinner from "react-spinner-material";
import './LoadingOverlay.css';

const StyledLoadingOverlay = styled.div`
    background-color: rgba(0, 0, 0, 0.55);
    align-items: center;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 100;
    h3 {
        color: #ffffff;
        font-weight: bold;
        padding: 8px;
        text-shadow: 2px 2px rgba(0, 0, 0, 0.55);
    }
`;

const LoadingOverlay = ({ show = true, message = "Cargando..." }) => {
    return (
        show && (
            <StyledLoadingOverlay>
                <Spinner className="loading-overlay" color="#0099cc" stroke={5} visible />
                <br />
                <h3 className="text-center">{message}</h3>
            </StyledLoadingOverlay>
        )
    );
};

export default React.memo(LoadingOverlay);
